import useTranslation from '@/hooks/use-translation';

type QuestionAndAnswer = {
  title: string;
  answer: string;
  bulletPoints?: Array<string>;
  observation?: string;
};

const useAllFAQQuestions = () => {
  const { t } = useTranslation('components.growth.faq');

  const getAllQuestions = (): Array<QuestionAndAnswer> =>
    Array(7)
      .fill(0)
      .map((_, index) => index + 1)
      .map((index) => ({
        title: t(`questions.question-${index}.title`),
        answer: t(`questions.question-${index}.answer`),
        bulletPoints: t(`questions.question-${index}.bullet-points`)
          ? t(`questions.question-${index}.bullet-points`).split('\n')
          : undefined,
        observation: t(`questions.question-${index}.observation`) || undefined,
      }));

  return { getAllQuestions };
};

export default useAllFAQQuestions;
